import { render } from "./Battles.vue?vue&type=template&id=234fc8c3&scoped=true"
import script from "./Battles.vue?vue&type=script&lang=js"
export * from "./Battles.vue?vue&type=script&lang=js"

import "./Battles.vue?vue&type=style&index=0&id=234fc8c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234fc8c3"]])

export default __exports__